import { User } from "../../../../store/auth/type/user";


export function getDefaultValue(user?: User) {
  return {
    fullName: user?.fullName || '',
    email: user?.email || '',
    phone: user?.phone || '',
    description: '',
    file: null,
  };
}